import * as React from 'react'
import { useSelector } from 'react-redux'
import { Col, Container, Row, Visible, config, Hidden } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import { Carousel } from '@components/home/Carousel'
import FadeInContent from '@components/shared/FadeInContent'
import { colors } from '@components/shared/colors'
import { QueensH1, GoodSansB2 } from '@components/shared/typography'
import { CTAPrimary } from '@components/shared/buttons'
import type { HeaderSectionPropsType } from '../HeaderSection'
import type { AppStateType } from '../../reducers/appstate'
import { TagPillRow } from '@components/Tag/TagPillRow'

export default function HeaderLayout (props: HeaderSectionPropsType & { openSubscribe: ()=> void }): React.ReactNode {
  const isSubscribed = useSelector((state: AppStateType): boolean => !!(state.user || {}).isSubscribed)
  const subscriptionCta = useSelector((state: AppStateType): string => state.subscriptionCTA)
  return (
    <Container>
    <Row >
      <Col
        xs={4}
        sm={8}
        md={4}
        lg={5}
        xl={5}
        offset={{ md: 0, lg: 1, xl: 1 }}
        justify={'center'}
      >
      <FadeInContent>
        <HeaderTextContainer>
          <HeaderText>{props.title}</HeaderText>
          {props.tags && <TagContainer><TagPillRow id={props.title} small tags={props.tags} /></TagContainer>}
          {!!props.description &&
            <Hidden xs={true} sm={true}><Description>{props.description}</Description></Hidden>}
          {!!props.description2 && <Visible xs={true} sm={true}>
            <Description>{props.description2}</Description>
          </Visible>}
          {!isSubscribed && <CTAPrimary className={'subscribe-cta'} onClick={props.openSubscribe}>{props.ctaText || subscriptionCta}</CTAPrimary>}
        </HeaderTextContainer>
      </FadeInContent>
      </Col>
      <Visible xs={false} sm={false} md={true} lg={true} xl={true}>
        <Col xs={4} sm={8} md={4} lg={5} xl={5} align={'center'} justify={'center'}>
          <FadeInContent>
            <Carousel {...(props as any)} />
          </FadeInContent>
        </Col>
      </Visible>
    </Row>
  </Container>
  )
}
const TagContainer = styled.div<any>`
  display: flex;
  .TagPillRow {
    justify-content: center;
    ${(props: any): any => config(props).media.md`
      justify-content: flex-start;
    `}
    div, a {
      border-color: ${colors.sand};
      color: ${colors.sand};
    }
  }
`
const HeaderTextContainer = styled.div<any>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0 40px;
  min-height: 40vh;
  gap: 1rem;
  h1,
  p,
  div {
    text-align: center;
  }

  ${(props: any): any => config(props).media.md`
    align-items: flex-start;
    h1,
    p,
    div {
      text-align: left;
    }
  `}
`
const HeaderText = styled.h1<any>`
  ${QueensH1};
  color: ${colors.sand};
`
const Description = styled.p<any>`
  ${GoodSansB2};
  color: ${colors.sand};
  margin: 0 0 1em;
`
